module.exports = __webpack_public_path__ + "img/punkte_4_bis_7.266a7627.png";